import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Manifesto from "@/pages/Manifesto";
import Pricing from "@/pages/Pricing";
import SignIn from "@/pages/SignIn";
import SignUp from "@/pages/SignUp";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Browse from "@/pages/Browse";
import ListingDetail from "@/pages/ListingDetail";
import ListingNew from "@/pages/ListingNew";
import ProfileEdit from "@/pages/ProfileEdit";
import MessageThread from "@/pages/MessageThread";
import SubscriptionSuccess from "@/pages/SubscriptionSuccess";
import Unsubscribe from "@/pages/Unsubscribe";
import EmailPreferences from "@/pages/EmailPreferences";
import AdminScheduler from "@/pages/AdminScheduler";
import Founding from "@/pages/Founding";
import Press from "@/pages/Press";
import { Privacy, Terms } from "@/pages/Legal";

function AppRouter() {
  const location = useLocation();
  // If returning from Emergent Google Auth, route to callback first
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <NavBar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/manifesto" element={<Manifesto />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/browse/:kind" element={<Browse />} />
        <Route path="/listings/new" element={<ProtectedRoute><ListingNew /></ProtectedRoute>} />
        <Route path="/listings/:id" element={<ListingDetail />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><ProfileEdit /></ProtectedRoute>} />
        <Route path="/messages/:otherId" element={<ProtectedRoute><MessageThread /></ProtectedRoute>} />
        <Route path="/subscription/success" element={<ProtectedRoute><SubscriptionSuccess /></ProtectedRoute>} />
        <Route path="/unsubscribe" element={<Unsubscribe />} />
        <Route path="/email-preferences" element={<ProtectedRoute><EmailPreferences /></ProtectedRoute>} />
        <Route path="/admin/scheduler" element={<ProtectedRoute><AdminScheduler /></ProtectedRoute>} />
        <Route path="/founding" element={<Founding />} />
        <Route path="/press" element={<Press />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
